import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import authService from '../../core/services/AuthService';
import LoadingMessageComponent from '../LoadingMessageComponent';

/**
 * ProtectedRoute component that ensures user is authenticated
 * before rendering the protected component
 */
const ProtectedRoute = ({ children, requiresAuth = true }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading, true/false = auth status
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const authenticated = await authService.checkAuthentication();
                setIsAuthenticated(authenticated);
                
                if (authenticated) {
                    const user = authService.getCurrentUser();
                    setUserInfo(user);
                } else if (requiresAuth) {
                    // If authentication is required and user is not authenticated,
                    // redirect to login
                    authService.login();
                    return;
                }
            } catch (error) {
                console.error('Error checking authentication:', error);
                setIsAuthenticated(false);
                if (requiresAuth) {
                    authService.login();
                }
            }
        };

        checkAuth();
    }, [requiresAuth]);

    // Show loading while checking authentication
    if (isAuthenticated === null) {
        return <LoadingMessageComponent />;
    }

    // If authentication is required but user is not authenticated,
    // show loading (while redirect happens)
    if (requiresAuth && !isAuthenticated) {
        return <LoadingMessageComponent />;
    }

    // If authentication is not required or user is authenticated, render children
    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    requiresAuth: PropTypes.bool
};

export default ProtectedRoute; 